import {queryClient} from "@app/appProvider/queryClient/queryClient";
import {
	QUERY_KEY_VOYAGE_TEMPLATE_BY_ID_SINGLE_VOYAGES,
	QUERY_KEY_VOYAGE_TEMPLATE_OUTDATED_SINGLE_VOYAGES,
	QUERY_KEY_VOYAGE_TEMPLATES_SINGLE_VOYAGES
} from "@containers/singleVoyage/voyageTemplates/queryHooks/constants/queryKey";

export const refetchVoyageTemplatesSingleVoyage = () => {
	queryClient.invalidateQueries({queryKey: [QUERY_KEY_VOYAGE_TEMPLATES_SINGLE_VOYAGES]});
	queryClient.invalidateQueries({queryKey: [QUERY_KEY_VOYAGE_TEMPLATE_BY_ID_SINGLE_VOYAGES]});
	queryClient.invalidateQueries({queryKey: [QUERY_KEY_VOYAGE_TEMPLATE_OUTDATED_SINGLE_VOYAGES]});
}
